export default __webpack_public_path__ + "static/compareBg-c1982c1c662096b9e85212cc13e754ca.png";